"use client";
import { Accordion } from "@/components/ui/accordion";
import { rafScrollIntoView } from "@/lib/utils";
import { useAppSelector } from "@/redux/hooks";
import { useEffect, useRef } from "react";

import { HotelCancellationFilter } from "./hotel-cancellation-filter";
import { HotelFacilitiesFilter } from "./hotel-facilities-filter";
import { HotelMealPlansFilter } from "./hotel-mealsPlan-filter";
import { HotelNameFind } from "./hotel-name-find";
import { HotelPriceRangeFilter } from "./hotel-price-range-filter";
import { HotelRatingFilter } from "./hotel-rating-filter";
import { HotelRoomsType } from "./hotel-roomstype-filter";

export function HotelFilterSection() {
  const resultsRootRef = useRef<HTMLDivElement | null>(null);

  const { isLoading } = useAppSelector((state) => state.selectedHotelData);

  useEffect(() => {
    if (!isLoading) {
      rafScrollIntoView(resultsRootRef.current);
    }
  }, [isLoading]);

  return (
    <Accordion
      ref={resultsRootRef}
      className="space-y-2 py-2"
      type="multiple"
      defaultValue={
        [
          "hotel_name",
          "price",

          "facilities",
          "mealPlans",
          // "roomTypes",
          "ratings",
          "cancellation",
        ].filter(Boolean) as string[]
      }
    >
      <HotelNameFind />
      <HotelPriceRangeFilter />
      <HotelCancellationFilter />
      <HotelMealPlansFilter />
      <HotelRatingFilter />
      <HotelRoomsType />
      <HotelFacilitiesFilter />
    </Accordion>
  );
}
